import React from 'react'

import OpenConversationV2 from './OpenConversationV2'
import ShowMoreLess from '../../../atoms/ShowMoreLess'

import { reformatLatestActivity } from '../../../../providers/SocketProvider/helpers'
import { newestDateComparator } from '../../../organisms/Conversations'
import { useQueueState } from '../../../../providers/QueueStateProvider'
import useStyles from './styles'

const OpenConversationsV2 = ({ user }) => {
  const { conversations } = useQueueState()
  const [expanded, setExpanded] = React.useState(false)

  const related = React.useMemo(() => {
    if (!user) {
      return []
    }

    const all = Object.values(conversations)
    const filtered = all.filter(conv => conv.owner_id === user.id)
    const formatted = filtered.map(conv => {
      const latest_activity = (conv.latest_activity ?? []).map(
        reformatLatestActivity
      )
      return { ...conv, latest_activity }
    })

    return formatted
  }, [user, conversations])

  React.useEffect(() => {
    setExpanded(false)
  }, [user])

  const sorted = React.useMemo(() => {
    const copy = related.slice()
    return copy.sort(newestDateComparator)
  }, [related])

  const convosToRender = React.useMemo(
    () => (expanded ? [...sorted] : [...sorted].slice(0, 3)),
    [expanded, sorted]
  )

  const classes = useStyles()

  if (convosToRender.length === 0) {
    return <div className={classes.empty}>No recent conversations</div>
  }

  return (
    <>
      <div className={classes.root}>
        {convosToRender.map(convo => (
          <OpenConversationV2
            showUnread
            key={convo.session}
            conversation={convo}
          />
        ))}
      </div>
      {sorted.length > 3 && (
        <ShowMoreLess expanded={expanded} setExpanded={setExpanded} />
      )}
    </>
  )
}

export default OpenConversationsV2
